import { SolutionsSearchParams, TypesOnSolutionHelper } from 'app/shared/objects/solutions';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { SolutionPerCityIndicatorHeaderHelper } from 'app/shared/objects/cities';
import { Pagination } from 'app/shared/pagination/pagination';
import { SolutionFilterHelper } from 'app/shared/services/forms.service';

@Injectable()
export class CitiesSolutionService {

  constructor(private http: HttpClient) { }

  getSolutions(params: SolutionsSearchParams) {
    return this.http.post(environment.apiURL + '/frontEndOpen/citiesSolutionsPaginate', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getIndicators() {
    return this.http.get(environment.apiURL + '/frontEndOpen/indicators')
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      })
  }

  postFilterSolution(filter: SolutionFilterHelper) {
    return this.http.post(environment.apiURL + '/frontEndOpen/solutions', filter)
      .toPromise()
      .then(response => {
        return response as Pagination[];
      })
      .catch(error => {
        return null;
      });
  }


  getSolutionFeatured() {
    return this.http.get(environment.apiURL + '/frontEndOpen/solutions/featured')
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  getRegions(country: string): Promise<string[]> {
    return this.http.get<string[]>(environment.apiURL + `/frontEndOpen/regions?country=${country}`)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      })
  }

  getCountries(): Promise<string[]> {
    return this.http.get<string[]>(environment.apiURL + '/frontEndOpen/countries')
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      })
  }

  postFilterSolutionRandom(params: SolutionsSearchParams) {
    return this.http.post(environment.apiURL + '/frontEndOpen/randomSolutions', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }


  getFilters() {
    return this.http.get(environment.apiURL + '/frontEndOpen/solutionList')
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getSolutionSingle(id: string) {
    return this.http.get(environment.apiURL + '/frontEndOpen/citySolution/' + id)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }
  getSolutionCity(solutionId: string, cityID: string, indicatorId: string): Promise<SolutionPerCityIndicatorHeaderHelper> {
    return this.http.get(environment.apiURL + '/dashboard/indicatorImprovement/' + solutionId + '/' + cityID + '/' + indicatorId)
      .toPromise()
      .then(response => {
        return response as SolutionPerCityIndicatorHeaderHelper;
      })
      .catch(error => {
        return null;
      });
  }

  getTypeSolutionOpen(): Promise<TypesOnSolutionHelper> {
    return this.http.get(environment.apiURL + '/frontEndOpen/typesOnSolution')
      .toPromise()
      .then(response => {
        return response as TypesOnSolutionHelper;
      })
      .catch(error => {
        return null;
      });
  }
}
